import React, { useEffect, useState } from "react";
import { GlobalSettingService } from "../../services";
import { toast } from "react-toastify";
import { handleConsoleError } from "../../utils/common-methods";

const PaymentTermsandcondition = (props) => {
  const [filteredData, setFilteredData] = useState(null);

  const getPyementermsAndConditions = async () => {
    try {
     // props.application.setLoading(true);
      const res = await GlobalSettingService.getPaymentTermsConditionsList();
      if (res?.isSuccess) {
        const decodedHtml = decodeHtml(res?.data?.keyValue);
        setFilteredData(decodedHtml);
      //  props.application.setLoading(true);
      } else {
        // toast.error(
        //   res?.message || res?.Errors?.[0]?.Message || "Something went wrong",
        // );
        props.application.setLoading(false);
      }
    } catch (error) {
      const message = handleConsoleError(error);
     // props.application.setLoading(false);
      toast.error(error?.message || message);
    } finally {
    }
  };

  const decodeHtml = (html) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea?.value;
  };

  useEffect(() => {
    getPyementermsAndConditions();
  }, []);

  return (
    <>
      <section className="account-login">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="account-profile">
                <h4>Payment Terms</h4>
                <div className="account-profile1"></div>
              </div>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="account-profile second">
                <h5>
                  <span style={{ height: "40px" }}></span>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="row">
        <div className="col-12">
          <div className="account-profile editor-container">
            <div
              className="editor-content"
              dangerouslySetInnerHTML={{ __html: filteredData }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentTermsandcondition;
